import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

const ArrowExpand = (props: SvgIconProps) => {
  return (
    <SvgIcon width="7" height="12" viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.263 6a.735.735 0 0 1-.216.521l-4.526 4.526A.737.737 0 1 1 .48 10.005L4.483 6 .48 1.995A.737.737 0 0 1 1.52.953L6.047 5.48A.735.735 0 0 1 6.263 6z"
        fill="#5D6672"
        fillRule="nonzero"
      />
    </SvgIcon>
  );
};

export default ArrowExpand;
